import { render } from "./ExpenseDetail.vue?vue&type=template&id=2fef6c24&scoped=true"
import script from "./ExpenseDetail.vue?vue&type=script&lang=js"
export * from "./ExpenseDetail.vue?vue&type=script&lang=js"

import "./ExpenseDetail.vue?vue&type=style&index=0&id=2fef6c24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fef6c24"]])

export default __exports__